<app-modal class="process-type-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title"
            *ngIf="!isEditMode; else editTitle">{{ 'admin.equipment.processTypes.create-modal.title' | translate }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.equipment.processTypes.update-modal.title' | translate }}</h5>
        </ng-template>
    </ng-container>
    <div class="body" modal-body>
        <form class="process-type-form" [formGroup]="processTypeForm">
            <app-material class="process-type-card">
                <div class="header" header>
                    <h5>{{ 'admin.equipment.processTypes.create-modal.sections.general' | translate }}</h5>
                </div>
                <div class="body" body>
                    <div class="form-row switch-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.isDestructive-input.label' | translate }}</label>
                        <app-input-switch
                            tooltipText="{{'admin.equipment.processTypes.create-modal.isDestructive-input.toolTip' | translate}}"
                            class="switch" formControlName="isDestructive"
                            [formControl]="processTypeForm.controls['isDestructive']"
                            [inline]="true">
                        </app-input-switch>
                    </div>
                    <div class="form-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.name-input.label' | translate }}</label>
                        <app-input [formControl]="processTypeForm.controls['name']"
                                   [showErrors]="showValidations"
                                   placeholder="{{'admin.equipment.processTypes.create-modal.name-input.placeholder' | translate }}">
                        </app-input>
                    </div>
                    <div class="form-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.description-input.label' | translate }}</label>
                        <app-textarea [formControl]="processTypeForm.controls['description']"
                                   [showErrors]="showValidations"
                                   placeholder="{{'admin.equipment.processTypes.create-modal.description-input.placeholder' | translate }}">
                        </app-textarea>
                    </div>
                </div>
            </app-material>
            <app-material class="process-type-card">
                <div class="header" header>
                    <h5>{{ 'admin.equipment.processTypes.create-modal.sections.strainProperties' | translate }}</h5>
                </div>
                <div class="body" body>
                    <div class="form-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.technicalEvaluationClass-input.label' | translate }}</label>
                        <app-dropdown-autocomplete formControlName="technicalEvaluationClassId"
                                                   [formControl]="processTypeForm.controls.technicalEvaluationClassId"
                                                   name="technicalEvaluationClassId"
                                                   [showErrors]="showValidations"
                                                   [items]="riskClasses"
                                                   valueField="id"
                                                   displayField="name"
                                                   [emptyText]="'admin.equipment.processTypes.create-modal.technicalEvaluationClass-input.placeholder' | translate"
                                                   (selectItem)="onTechnicalEvaluationClassChange($event)">
                        </app-dropdown-autocomplete>
                    </div>
                    <div class="form-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.maximum-strain-measurement-value-input.label' | translate }}</label>
                        <app-input [formControl]="processTypeForm.controls['maximumStrainMeasurementValue']"
                                   [showErrors]="showValidations"
                                   [allowNegative]="false"
                                   [maxLength]="11"
                                   mask="separator.2"
                                   placeholder="{{'admin.equipment.processTypes.create-modal.maximum-strain-measurement-value-input.placeholder' | translate }}"
                                   type="number">
                        </app-input>
                    </div>
                    <div class="form-row">
                        <label>{{ 'admin.equipment.processTypes.create-modal.strainResponsible-input.label' | translate }}</label>
                        <app-dropdown-autocomplete
                            [formControl]="processTypeForm.controls.strainResponsible"
                            [items]="users"
                            valueField="id"
                            displayField="name"
                            [showErrors]="showValidations"
                            [appendTo]="'body'"
                            [emptyText]="'admin.equipment.processTypes.create-modal.strainResponsible-input.placeholder' | translate"
                            (selectItem)="onStrainResponsibleChange($event)">
                        </app-dropdown-autocomplete>
                    </div>
                </div>
            </app-material>
        </form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="!isEditMode && shouldRenderModifiers()"
                        type="primary"
                        [disabled]="isLoading"
                        (click)="createProcessType()">
                {{ 'admin.equipment.processTypes.create-modal.button.create'| translate }}
            </app-button>
            <app-button *ngIf="isEditMode && shouldRenderModifiers()"
                        type="warning"
                        [disabled]="isLoading"
                        (click)="updateProcessType()">
                {{ 'admin.equipment.processTypes.create-modal.button.update'| translate }}
            </app-button>
            <app-button type="danger"
                        *ngIf="isEditMode && shouldRenderModifiers()"
                        [disabled]="processType.inUse || isLoading"
                        (click)="deleteProcessType()">
                {{ 'admin.equipment.processTypes.create-modal.button.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
